import { Rect } from '../../../platform/geom/Rect';
import { Counter } from './Counter';

export const CounterLayout = (counter: Counter) => {
    const { width, height } = counter;

    const base = new Rect(0, 0, width, height);
    const screen = base.inflate(-15).set({ height: 50 });

    const dec = screen.set({
        top: screen.bottom + 10,
        width: 32,
        height: 32,
    });

    const inc = dec.set({
        left: screen.right - 32,
    });

    const reset = dec.set({
        left: dec.right + 20,
        width: 48,
    });

    return { base, screen, dec, reset, inc };
};

export type CounterLayout = ReturnType<typeof CounterLayout>;
